import React from "react";
import PropTypes from "prop-types";
import { TabsSwitcherContainer } from "./CompanyDetails.styles";

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const TabsSwitcher = ({
  tabs,
  activeTab,
  onChange,
  variant = "box",
  paramName,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (paramName) {
      const currentVal = searchParams.get(paramName);
      if (currentVal && currentVal !== activeTab) {
        const isValid = tabs.some((t) => t.key === currentVal);
        if (isValid) {
          onChange(currentVal);
        }
      }
    }
  }, [searchParams, paramName, activeTab, onChange, tabs]);

  const handleTabClick = (key) => {
    if (paramName) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set(paramName, key);
      setSearchParams(newParams);
    }
    onChange(key);
  };

  return (
    <TabsSwitcherContainer
      className={variant === "underline" ? "underline" : ""}
    >
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={activeTab === tab.key ? "tab-button active" : "tab-button"}
          onClick={() => handleTabClick(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </TabsSwitcherContainer>
  );
};

TabsSwitcher.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["box", "underline"]),
  paramName: PropTypes.string,
};

export default TabsSwitcher;
